<template>
  <div>
    <div class="foal-mare-content border-bottom-line">
      <div class="py-3">
        <div class="form-row check-as-radio-group">
          <div class="col-md-6">
            <div class="form-group">
              <label :for="'checkbox-mare-' + horseData.id" class="input-wrapper form-control"
                :class="{ active: horseData.horse_type === 'Mare' }">
                <h5>{{ 'javascript.horse_registration.mare' | trans }}</h5>
                <input value="Mare" name="horse_type" type="radio" v-model="horseData.horse_type"
                  :id="'checkbox-mare-' + horseData.id" class="checked-input rounded-circle horse-type_checkbox"
                  :class="{ active: horseData.horse_type === 'Mare' }" />
                <span class="checkbox__inner"></span>
              </label>
              <div></div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label :for="'checkbox-foal-' + horseData.id" class="input-wrapper form-control"
                :class="{ active: horseData.horse_type === 'Foal' }">
                <h5>{{ 'javascript.horse_registration.foal' | trans }}</h5>
                <input value="Foal" name="horse_type" v-model="horseData.horse_type" type="radio"
                  :id="'checkbox-foal-' + horseData.id" class="checked-input rounded-circle horse-type_checkbox"
                  :class="{ active: horseData.horse_type === 'Foal' }" />
                <span class="checkbox__inner"></span>
              </label>
              <div></div>
            </div>
          </div>
        </div>
      </div>

      <div class="mare-information">
        <div class="py-3">
          <h4>{{ 'javascript.horse_registration.select_type' | trans }}</h4>
          <div class="form-row check-as-radio-group">
            <div class="col-md-6">
              <div class="form-group">
                <label :for="'checkbox-warmblood' + horseData.id" class="input-wrapper form-control"
                  :class="{ active: horseData.type === 'Warmblood' }">
                  <h5>{{ 'javascript.horse_registration.warmblood' | trans }}</h5>
                  <input v-model="horseData.type" value="Warmblood" name="type" type="radio"
                    :id="'checkbox-warmblood' + horseData.id" class="checked-input rounded-circle"
                    :class="{ active: horseData.type === 'Warmblood' }" />
                  <span class="checkbox__inner"></span>
                </label>
                <div></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label :for="'checkbox-pony' + horseData.id" class="input-wrapper form-control"
                  :class="{ active: horseData.type === 'Pony' }">
                  <h5>{{ 'javascript.horse_registration.pony' | trans }}</h5>
                  <input v-model="horseData.type" value="Pony" name="type" type="radio"
                    :id="'checkbox-pony' + horseData.id" class="checked-input rounded-circle"
                    :class="{ active: horseData.type === 'Pony' }" />
                  <span class="checkbox__inner"></span>
                </label>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-3">
          <h4>{{ 'javascript.horse_registration.select_discipline' | trans }}</h4>
          <div class="form-row check-as-radio-group">
            <div class="col-md-6">
              <div class="form-group">
                <label :for="'checkbox-dressage' + horseData.id" class="input-wrapper form-control"
                  :class="{ active: horseData.discipline === 'Dressage' }">
                  <h5>{{ 'javascript.horse_registration.dressage' | trans }}</h5>
                  <input value="Dressage" name="discipline" v-model="horseData.discipline" type="radio"
                    :id="'checkbox-dressage' + horseData.id" class="checked-input rounded-circle"
                    :class="{ active: horseData.discipline === 'Dressage' }" />
                  <span class="checkbox__inner"></span>
                </label>
                <div></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label :for="'checkbox-jumping' + horseData.id" class="input-wrapper form-control"
                  :class="{ active: horseData.discipline === 'Jumping' }">
                  <h5>{{ 'javascript.horse_registration.jumping' | trans }}</h5>
                  <input value="Jumping" v-model="horseData.discipline" name="discipline" type="radio"
                    :id="'checkbox-jumping' + horseData.id" class="checked-input rounded-circle"
                    :class="{ active: horseData.discipline === 'Jumping' }" />
                  <span class="checkbox__inner"></span>
                </label>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-3" :class="{ 'd-none': !(horseData.horse_type === 'Foal') }">
          <h4>{{ 'javascript.horse_registration.select_sex' | trans }}</h4>
          <div class="form-row check-as-radio-group">
            <div class="col-md-6">
              <div class="form-group">
                <label :for="'checkbox-colt-' + horseData.id" class="input-wrapper form-control"
                  :class="{ active: horseData.sex === 'Colt' }">
                  <h5>{{ 'javascript.horse_registration.colt' | trans }}</h5>
                  <input name="sex" v-model="horseData.sex" value="Colt" type="radio"
                    :id="'checkbox-colt-' + horseData.id" class="checked-input rounded-circle custom-checkbox"
                    :class="{ active: horseData.sex === 'Colt' }" />
                  <span class="checkbox__inner"></span>
                </label>
                <div></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label :for="'checkbox-filly-' + horseData.id" class="input-wrapper form-control "
                  :class="{ active: horseData.sex === 'Filly' }">
                  <h5>{{ 'javascript.horse_registration.filly' | trans }}</h5>
                  <input value="Filly" v-model="horseData.sex" name="sex" type="radio"
                    :id="'checkbox-filly-' + horseData.id" class="checked-input rounded-circle"
                    :class="{ active: horseData.sex === 'Filly' }" />
                  <span class="checkbox__inner"></span>
                </label>
                <div></div>
              </div>
            </div>
          </div>
        </div>

        <FileUpload name="images" text="javascript.horse_registration.upload_text"
          second-text="javascript.horse_registration.you_can_attach_photo" :class="{ 'd-none': !haveUploadedFile }"
          :horse-id="horseData.id" />


      </div>
      <a class="btn-link text-body d-inline-block mt-1" v-if="horse.mare_jumping_score_file" target="_blank"
        :href="horse.mare_jumping_score_file">
        {{ 'javascript.horse_registration.uploaded_file' | trans }}
      </a>
      <img v-if="horse.mare_jumping_score_file && isImage(horse.mare_jumping_score_file)"
        class="img-thumbnail my-account-image" :src="horse.mare_jumping_score_file" alt="Warmblood Jumping score">
    </div>

    <div class="step-2-information">
      <h3 class="personal-text font-heading">
        {{ 'javascript.horse_registration.information' | trans }}
      </h3>

      <div class="form-row">
        <div class="col-md-4">
          <fieldset class="form-group name-input">
            <input type="text" name="horse_name" v-model="horseData.horse_name" class="form-control" />
            <label class="form-control-placeholder" for="horse_name">{{
              'javascript.horse_registration.foal_name' | trans
            }}</label>
          </fieldset>
        </div>

        <div class="col-md-4 ">
          <fieldset class="lifeid">
            <select name="life_id_prefix" v-model="horseData.life_id_prefix" class="form-control w-200-select"
              data-role="select" data-filter="false" id="life_id_prefix">
              <option value="null">&nbsp;</option>
              <option v-for="(prefix, key) in lifeIdPrefixes" :key="key" :value="key">{{ prefix }}</option>
            </select>
            <label class="form-control-placeholder" for="life_id_prefix">{{
              'javascript.horse_registration.life_id' | trans
            }}<span class="icon-tooltip" onclick="$('#lifeid-popup').data('infobox').open()">?</span>
            </label>
            <input type="text" name="life_id" v-model="horseData.life_id" class="form-control" required />
          </fieldset>
        </div>

        <div class="col-sm-4">
          <fieldset class="form-group name-input">
            <input type="date" name="date_of_birth" v-model="horseData.date_of_birth" :min="dateOfBirthMin"
              :max="dateOfBirthMax" class="form-control custom-font" id="date_of_birth" />
            <label class="form-control-placeholder" for="date_of_birth">
              {{ 'javascript.horse_registration.date_of_birth' | trans }}
            </label>
          </fieldset>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 col-sm-6">
          <fieldset>
            <select name="lot_color_id" v-model="horseData.lot_color_id" class="form-control" data-role="select"
              data-filter="false" id="lot_color_id" required>
              <option value="null">
                {{
                  'javascript.horse_registration.select_a_color' | trans
                }}
              </option>
              <option v-for="(color, index) in lotColors" :value="index">{{
                color
              }}
              </option>
            </select>
            <label class="form-control-placeholder" for="lot_color_id">{{
              'javascript.horse_registration.color' | trans
            }}</label>
          </fieldset>
        </div>

        <div class="col-12 col-md-6">
          <!-- <select name="lot_breed_id" v-model="horseData.lot_breed_id" class="form-control" data-role="select"
                    data-filter="false" required>
              <optgroup :label="gIndex" v-for="(group, gIndex) in lotBreeds" :key="gIndex">
                <option v-for="(breed, index) in group" :value="index">{{ breed }}</option>
              </optgroup>
            </select> -->

          <MetroSelect v-if="horseData.type === 'Warmblood'"
            :placeholder="'javascript.horse_registration.select_a_breeding_association'" key="Warmblood" id="Warmblood"
            :data="lotBreeds.Warmblood" name="lot_breed_id" v-model="horseData.lot_breed_id" required />
          <MetroSelect v-else key="Pony" id="Pony" :data="lotBreeds.Pony"
            :placeholder="'javascript.horse_registration.select_a_breeding_association'" name="lot_breed_id"
            v-model="horseData.lot_breed_id" required />
        </div>

        <template v-if="horseData.horse_type !== 'Mare'">
          <!--          <div class="col-12 col-sm-3" v-if="false">
            <fieldset :id="'vat-wrap' + horseData.id">
              <select name="vat" class="form-control" data-role="select" data-filter="false" required>
                <option v-for="(vat, index) in vats" :value="index">{{ vat }}</option>
              </select>

              <label class="form-control-placeholder" for="type">VAT for sale</label>
            </fieldset>
          </div>-->
          <div class="col-12">
            <fieldset :id="'sale-status-wrap-' + horseData.id">
              <h4 class="mb-3">{{ 'javascript.horse_registration.saleability' | trans }}</h4>
              <input type="radio" checked data-role="radio" v-model="horseData.sale_status" name="sale_status"
                value="The foal is for sale"
                :data-caption="$options.filters.trans('javascript.horse_registration.the_foal_is_for_sale')">
              <div class="subinputs">
                <input type="checkbox" data-role="checkbox" v-model="horseData.sale_is_for_h24_championship"
                  @change="updateSaleStatus" name="sale_is_for_h24_championship"
                  :data-caption="$options.filters.trans('javascript.horse_registration.h24_championship_sale_text')">
                <input type="checkbox" data-role="checkbox" v-model="horseData.sale_is_for_breeding_association_auction"
                  @change="updateSaleStatus" name="sale_is_for_breeding_association_auction"
                  :data-caption="$options.filters.trans('javascript.horse_registration.breeding_association_auction_sale_text')"><br>
                <input type="checkbox" data-role="checkbox" v-model="horseData.sale_is_private" @change="updateSaleStatus"
                  name="sale_is_private"
                  :data-caption="$options.filters.trans('javascript.horse_registration.private_sale_text')">
              </div>
              <input type="radio" data-role="radio" v-model="horseData.sale_status" name="sale_status"
                value="The foal is not for sale"
                :data-caption="$options.filters.trans('javascript.horse_registration.the_foal_is_not_for_sale')">
              <input type="radio" data-role="radio" v-model="horseData.sale_status" name="sale_status"
                value="Not decided yet"
                :data-caption="$options.filters.trans('javascript.horse_registration.not_decided_yet')">
            </fieldset>
          </div>
        </template>

        <div class="col-12 mt-5">
          <pedigree-view show-horse-link ref="horse-pedigree" :pedigrees="horseData.pedigree" :horse-id="horseData.id"
            :mare-primes="marePrimes">
          </pedigree-view>
        </div>
        <div class="col-12 mt-1">
          <FileUpload name="pedigree" text="javascript.horse_registration.upload_pedigree_text"
            :horse-id="horseData.id" />

          <a class="btn-link text-body d-inline-block mt-1" v-if="horse.pedigree_file" target="_blank"
            :href="horse.pedigree_file">
            {{ 'javascript.horse_registration.uploaded_file' | trans }}
          </a>
          <img v-if="horse.pedigree_file && isImage(horse.pedigree_file)" class="img-thumbnail my-account-image"
            :src="horse.pedigree_file" alt="Pedigree from certificate">
        </div>
      </div>
    </div>
    <div class="info-box" id="lifeid-popup" data-role="infobox" data-overlay="true">
      <span class="button square closer"></span>
      <div class="info-box-content">
        <p>{{ 'javascript.horse_registration.life_id_helper_text' | trans }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import FileUpload from './FileUpload.vue'
import PedigreeView from '../Pedigree/Registration/Parents.vue'
import MetroSelect from './MetroSelect.vue'
import moment from 'moment'

export default {
  name: 'HorseInformation',
  components: {
    FileUpload,
    PedigreeView,
    MetroSelect
  },
  props: {
    horse: {
      type: Array | Object,
      require: true
    },
    lotColors: {
      type: Array | Object
    },
    lotBreeds: {
      type: Array | Object
    },
    saleStatuses: {
      type: Array | Object
    },
    marePrimes: {
      type: Array | Object,
      default() {
        return null
      }
    }
  },
  watch: {
    'horseData.sale_status': function (newVal, oldVal) {
      if (newVal !== 'The foal is for sale') {
        this.horseData.sale_is_for_h24_championship = false
        this.horseData.sale_is_for_breeding_association_auction = false
        this.horseData.sale_is_private = false
      }
    },

  },
  data() {
    return {
      horseData: {},
      lifeIdPrefixes: {
        DE: 'DE',
        NLD: 'NLD',
        BEL: 'BEL',
        DNK: 'DNK',
        SWE: 'SWE',
        FIN: 'FIN',
        AUT: 'AUT',
        CHE: 'CHE',
        FRA: 'FRA',
        GBR: 'GBR',
        IRL: 'IRL',
        ESP: 'ESP',
        ITA: 'ITA',
        POL: 'POL',
        HUN: 'HUN'
      },
      vats: [0, 9.5, 19]
    }
  },
  created() {
    this.horseData = this.horse

    if (!Object.keys(this.lotColors).includes(this.horse.lot_color_id.toString())) {
      this.horseData.lot_color_id = 'null'
    }
  },
  methods: {
    updateSaleStatus(value) {
      if (this.horseData.sale_status !== 'The foal is for sale' && value.target.value === 'on') {
        this.horseData.sale_status = 'The foal is for sale'
      }
    },
    isImage(path) {
      return ['png', 'jpg', 'jpeg'].some(val => path.endsWith(val))
    }
  },
  computed: {
    haveUploadedFile() {
      return this.horseData.type !== 'Pony' && this.horseData.horse_type === 'Mare' && this.horseData.discipline === 'Jumping'
    },

    dateOfBirthMin() {
      if (this.horseData.horse_type === "Mare") {
        return moment().subtract(3, "Year").startOf("year").format("Y-MM-DD")
      } else {
        return moment().startOf("year").format("Y-MM-DD")
      }
    },

    dateOfBirthMax() {
      if (this.horseData.horse_type === "Mare") {
        return moment().subtract(3, "Year").endOf("year").format("Y-MM-DD")
      } else {
        return moment().format("Y-MM-DD")
      }
    },
    pedigreeFiles() {
      return this.horse.media.filter((item) => {
        return item.collection_name === 'pedigree'
      })
    },
    documentFiles() {
      return this.horse.media.filter((item) => {
        return item.collection_name === 'documents'
      })
    }
  }
}
</script>

<style>
img.img-thumbnail.my-account-image {
  max-width: 8em;
}
</style>
